@layer module {
.label-value-wrapper {
            width: 100%;
            display: grid;
            align-items: center;
    }

.label-value-wrapper .value {
            word-wrap: break-word;
    }

.label-value-wrapper .copy-box {
            border-width: 1px;
            border-style: solid;
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: space-between;
    }

.label-value-wrapper .copy-box span {
            overflow-wrap: anywhere;
            word-break: break-all;
    }
} // layer module










@layer app {
.label-value-wrapper {
            padding: $size-9 0 $size-9 $size-30;
            grid-template-columns: $size-30 1fr;
            gap: $size-30;
    }

.label-value-wrapper .label {
            margin: 0;
    }

.label-value-wrapper .copy-box {
            border-radius: $size-3;
            padding: $size-5;
    }

.label-value-wrapper .copy-box span {
            margin: 0 $size-10;
    }

.label-value-wrapper {
            font-size: var(--font-size-base);
    }

.label-value-wrapper .label {
            color: var(--label-value-key-text);
    }

.label-value-wrapper .value {
            color: var(--label-value-value-text);
            font-weight: 600;
    }

.label-value-wrapper .copy-box span {
            font-size: var(--font-size-base);
    }

.label-value-wrapper .copy-box {
            border-color: var(--field-divider);
    }
} // layer app
